module.exports = __webpack_public_path__ + "static/img/6.878cb43.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/6.png
// module id = jClu
// module chunks = 0